export const SHOW_COMMENT_THREADS_STORAGE_PREFIX = 'conversations.showCommentThreads';

const resolvePreferenceScope = (
  tenantId?: string,
  employeeId?: string,
  username?: string,
): { tenantId: string; userKey: string } | null => {
  const tenant = tenantId?.trim();
  const userKey = (employeeId?.trim() || username?.trim() || '').toLowerCase();

  if (!tenant || !userKey) {
    return null;
  }

  return { tenantId: tenant, userKey };
};

export const getShowCommentThreadsStorageKey = (tenantId: string, userKey: string): string => {
  const tenant = tenantId.trim().toLowerCase();
  const user = userKey.trim().toLowerCase();
  return `${SHOW_COMMENT_THREADS_STORAGE_PREFIX}:${tenant}:${user}`;
};

export const readShowCommentThreadsPreference = (
  tenantId?: string,
  employeeId?: string,
  username?: string,
): boolean => {
  const scope = resolvePreferenceScope(tenantId, employeeId, username);
  if (!scope) {
    return true;
  }

  try {
    const stored = localStorage.getItem(getShowCommentThreadsStorageKey(scope.tenantId, scope.userKey));
    if (stored === 'false') {
      return false;
    }

    if (stored === 'true') {
      return true;
    }
  } catch {
    // Ignore storage access failures.
  }

  return true;
};

export const writeShowCommentThreadsPreference = (
  showCommentThreads: boolean,
  tenantId?: string,
  employeeId?: string,
  username?: string,
): void => {
  const scope = resolvePreferenceScope(tenantId, employeeId, username);
  if (!scope) {
    return;
  }

  try {
    localStorage.setItem(
      getShowCommentThreadsStorageKey(scope.tenantId, scope.userKey),
      showCommentThreads ? 'true' : 'false',
    );
  } catch {
    // Ignore storage access failures.
  }
};
